export default __webpack_public_path__ + "static/media/Dmitri-Particle_0000_SpikeImpactParticle.096d5818.png";